import React, { useMemo } from 'react';
import { NfcCardPermission } from 'types';
import { ISelectOption } from 'components/Select/types';
import { nfcCardPermission } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormSelect from 'components/Select/FormSelect';

interface IProps {
	settingsId: string;
	onChange: (value: NfcCardPermission[]) => void;
}

export const NfcCardPermissionSelect: React.FC<IProps> = ({ settingsId, onChange }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectNfcCardPermission') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => nfcCardPermission.filter((item) => item.id !== 'None'), []);

	return (
		<FormSelect
			testId="NfcCardPermissionSelect"
			name={`nfcCardPermission-${settingsId}`}
			label="permissionsOfCardLabel"
			translationNameSpace="form"
			mode="multiple"
			showSearch={false}
			options={mappedOptions}
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};
